(() => {
  if (window.muyaFooterBreadcrumbReady) return;
  window.muyaFooterBreadcrumbReady = true;
  const init = (root = document) => {
    root.querySelectorAll('[data-muya-footer-breadcrumb]').forEach((nav) => {
      if (nav.dataset.muyaBreadcrumbReady) return;
      nav.dataset.muyaBreadcrumbReady = 'true';
      const mobile = window.matchMedia('(max-width: 767px)');
      let interacted = false;
      const align = () => {
        if (!nav.isConnected || !mobile.matches || interacted) return;
        const rtl = getComputedStyle(nav).direction === 'rtl';
        nav.scrollLeft = rtl ? -nav.scrollWidth : nav.scrollWidth;
      };
      const controller = new AbortController();
      const { signal } = controller;
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((event) => {
        nav.addEventListener(event, () => { interacted = true; }, { passive: true, signal });
      });
      const onChange = () => { interacted = false; requestAnimationFrame(align); };
      mobile.addEventListener('change', onChange);
      requestAnimationFrame(align);
      document.fonts?.ready.then(align);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(nav)) return;
        controller.abort();
        mobile.removeEventListener('change', onChange);
      }, { signal });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
